'use client';

import { useClientTranslation } from '@lib/i18n/client';
import { AlertDialog } from '@tuic/web-compositions/shared/AlertDialog';

import type { FC } from 'react';

/**
 * FAQ entry explaining the "booking already linked" situation, per locale.
 */
const FAQ_URLS: Record<string, string> = {
  de: 'https://www.meinschiff.com/de/faq/mein-schiff-app#faq_2765',
  en: 'https://www.meinschiff.com/en/faq/mein-schiff-app#faq_2765',
};

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Masked email of the linked account. Omitted until the backend delivers it. */
  maskedEmail?: string;
};

export const BookingAlreadyLinkedDialog: FC<Props> = ({
  open,
  onOpenChange,
  maskedEmail,
}) => {
  const { t, i18n } = useClientTranslation();

  const faqUrl = FAQ_URLS[i18n.resolvedLanguage ?? 'de'] ?? FAQ_URLS.de;

  return (
    <AlertDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('Diese Reise ist bereits verknüpft')}
      actions={[
        {
          title: t('Mehr dazu'),
          as: 'a',
          href: faqUrl,
          target: '_blank',
          rel: 'noreferrer',
        },
        {
          title: t('Schließen'),
          primary: true,
          onClick: () => onOpenChange(false),
        },
      ]}
    >
      <p>
        {t(
          'Diese Reise wurde bereits einem anderen Mein Schiff® Konto zugeordnet:',
        )}
      </p>
      {maskedEmail && (
        <p className="font-semibold text-marine-high-emphasis">{maskedEmail}</p>
      )}
      <p>
        {t(
          'Bitte melden Sie sich mit diesem Konto an oder kontaktieren Sie unseren Kundenservice oder Ihre Buchungsstelle, wenn Sie Unterstützung benötigen. Sie können alte Konten auch über die Konto-Details eigenständig löschen.',
        )}
      </p>
    </AlertDialog>
  );
};
